<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{ `${$t("modal.station_config.speaker.edit")} ${props.name}` }}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>


      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="name" id="name" autocomplete="off" :class="{'invalid': submitted && v$.model.name.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.name')" v-model="model.name" maxLength="50">
          <label for="name">{{$t("modal.station_config.station.name")}} 
            <small v-if="submitted && v$.model.name.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="callSign" id="callSign" autocomplete="off" :class="{'invalid': submitted && v$.model.callSign.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.callSign')" v-model="model.callSign" maxLength="50">
          <label for="callSign">{{$t("modal.station_config.station.callSign")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="number" name="commercialBreakMaxTime" id="commercialBreakMaxTime" autocomplete="off" :class="{'invalid': submitted && v$.model.commercialBreakMaxTime.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.commercialBreakMaxTime')" v-model="model.commercialBreakMaxTime">
          <label for="commercialBreakMaxTime">{{$t("modal.station_config.station.commercialBreakMaxTime")}} 
            <small v-if="submitted && v$.model.commercialBreakMaxTime.$invalid" class="pill-required">* {{ $t("modal.common.required") }}</small>
            <small v-else>*</small>
          </label>
        </div>
      </div>

      <label style="color: #fff9;">
        <span v-html="$t('modal.station_config.station.drop').split(`'`)[1]"></span>
      </label>
      <label for="images" class="drop-container" v-if="model.image == '' || !model.image">
        <span v-html="$t('modal.station_config.station.drop')"></span>
        <input type="file" id="images" accept="image/*" @change="uploadImage">
      </label>

      <div class="drop-container selected" v-else>
        <div class="container-image">
          <img :src="getUrlImage(model.image)" alt="image-station" style="width: 100%">
        </div>
        
        <i class="material-icons remove" @click="model.image = ''">cancel</i>
      </div>

      <!-- Firma -->
      <label style="color: #fff9;">
        <span v-html="$t('modal.station_config.station.drop_signature').split(`'`)[1]"></span>
      </label>
      <label for="image_signature" class="drop-container" v-if="model.certifySignature == '' || !model.certifySignature"> 
        <span v-html="$t('modal.station_config.station.drop_signature')"></span>
        <input type="file" id="image_signature" accept="image/*" @change="uploadImageSignature">
      </label>

      <div class="drop-container selected" v-else>
        <div class="container-image">
          <img :src="getUrlImage(model.certifySignature)" alt="image-station" style="width: 100%">
        </div>
        
        <i class="material-icons remove" @click="model.certifySignature = ''">cancel</i>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <input type="text" name="signatureLabel" id="signatureLabel" autocomplete="off" :class="{'invalid': submitted && v$.model.certifySignatureSubject.$invalid}"
            :placeholder="$t('modal.placeholder_insert') + $t('modal.station_config.station.signature_label')" v-model="model.certifySignatureSubject" maxLength="50">
          <label for="signatureLabel">{{$t("modal.station_config.station.signature_label")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <div class="component-modal-input component-modal-input--rename">
          <select name="certifyLanguage" id="certifyLanguage" autocomplete="off" :class="{'invalid': submitted && v$.model.certifyLanguage.$invalid}" v-model="model.certifyLanguage">
            <option value="en-US">{{ $t("modal.station_config.station.english") }}</option>
            <option value="es-ES">{{ $t("modal.station_config.station.spanish") }}</option>
          </select>
          <label for="certify_language">{{$t("modal.station_config.station.certify_language")}}</label>
        </div>
      </div>

      <div class="component-modal__row">
        <button type="button" @click.stop.prevent="saveAndClose">
          {{ $t("modal.save") }}
        </button>
        <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
          {{ $t("modal.cancel") }}
        </button>
      </div>

      <div class="component-modal__row" v-if="submitted && v$.model.$invalid">
        <div class="modal__form-error">
          <i class="material-icons">info_outline</i>
          <span v-html="$t('modal.common.required_message', {inputs : v$.model.$silentErrors.map(error => $t(`modal.station_config.station.${error.$property}`)).join(', ') })"></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { maxLength, minValue, required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import storage from "@/plugins/azure-storage";
import eventBus from '@/plugins/eventBus';

export default {
  setup() {
		const v$ = useVuelidate();
    const store = useStore();
    const props = computed(() => store.getters.modal_getProps);
    const submitted = ref(false);
    const model = ref({
      name: '',
      callSign: '',
      commercialBreakMaxTime: 0,
      image: '',
      certifySignature: '',
      certifySignatureSubject: '',
      certifyLanguage: 'en-US'
    })

    onMounted(() => {
      if (props.value) model.value = Object.assign({}, props.value);
    })

    async function closeModal() {
      await store.dispatch('modal_setActive');
      submitted.value = false;
    }

    function getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_USER}${path}`
    }

    async function uploadImage(event) {
      const file = event.target.files[0]
      if(!file) return false;
      store.dispatch('loading_setActive', true);
      try {
        const imageName = await storage.updateFile(file);
        model.value.image = imageName; 
      } catch (error) {
        store.dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('notifications.uploadStationLogoError')}`, title: 'ERROR', error: true});
      } finally {
        store.dispatch('loading_setActive', false);
      }
    }

    async function uploadImageSignature(event) {
      const file = event.target.files[0]
      if(!file) return false;
      store.dispatch('loading_setActive', true);
      try {
        const imageName = await storage.updateFile(file);
        model.value.certifySignature = imageName; 
      } catch (error) {
        store.dispatch('notifications_create', {text: `${window.vueApp.$t('notifications.general')} ${window.vueApp.$t('notifications.uploadStationLogoError')}`, title: 'ERROR', error: true});
      } finally {
        store.dispatch('loading_setActive', false);
      }
    }

    async function saveAndClose() {
      submitted.value = true;
      if (!v$.value.model.$invalid) {
        try {
          await store.dispatch('station_update', model.value);
          eventBus.$emit('reloadStations');  
          this.closeModal();
        } catch (error) {
          console.error(error);
        }
      }
    }

    return {
      v$,
      props,
      model,
      submitted,
      saveAndClose,
      closeModal,
      uploadImage,
      getUrlImage,
      uploadImageSignature
    }
  },
	validations () {
    return {
      model: {
        name: {required, maxLengthValue: maxLength(50)},
				callSign: {maxLengthValue: maxLength(50)},
        commercialBreakMaxTime: {required, minValueValue: minValue(1)},
        certifySignatureSubject: {required},
        certifyLanguage: {required}
			}
    }
  }
};
</script>
<style lang="scss">
.drop-container {
  margin-top: 8px;
  text-align: center;

  small {
    color: white;
  } 
}
</style>